export default __webpack_public_path__ + "static/media/arrow_drop_down-Orange.13821072.svg";